import styled from 'styled-components';
export const StyledChidrenWrapper = styled.div `
  position: relative;
  min-height: ${({ theme }) => `calc(100% - ${theme.footer.height})`};
  display: flex;
  flex-direction: column;
`;
